<merchant-products [menuPermissionActive]="menuPermissionActive"></merchant-products>